interface NetworkErrorOptions {
  readonly cause: unknown
}

class NetworkError extends Error {
  constructor(message: string, options: NetworkErrorOptions) {
    // cause introduced in ES2022
    // @ts-expect-error - super is not typed
    super(message, { cause: options.cause })
    this.name = 'NetworkError'
  }
}

export { NetworkError }
